import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
	name: Yup.string().required().label('League name'),

});
const Inputs = [
	{
		name: 'name',
		label: 'Name',
		type: 'text',
		value: 'single',
		valueAttr: 'name',
	},
	{
		name: 'providerId',
		label: 'ProviderId',
		type: 'text',
		value: 'single',
		valueAttr: 'providerId',
	},
	{
		name: 'countryCode',
		label: 'CountryCode',
		type: 'text',
		value: 'single',
		valueAttr: 'countryCode',
	},
	{
		name: 'translations',
		label: 'Translations',
		type: 'nestedArray',
		value: 'multiple',
		valueAttr: 'translations',
		columns: [
			{
				name: 'languageCode',
				label: 'Language',
				type: 'text',
				required: true,
			},
			{
				name: 'translatedName',
				label: 'Translated Name',
				type: 'text',
				required: true,
			}
		]
	}

];

export { Inputs, validationSchema };
